import { render } from "./createMulti.vue?vue&type=template&id=88530152&scoped=true"
import script from "./createMulti.vue?vue&type=script&lang=js"
export * from "./createMulti.vue?vue&type=script&lang=js"

import "./createMulti.vue?vue&type=style&index=0&id=88530152&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88530152"

export default script